export default "__VITE_ASSET__DX8JnXKi__"